@import '../../styles/checkout-order-details.css';
@import '../../styles/form.css';


:host {
  display: block;
}

.order-details {
  border-bottom: 1px solid #d5d9de;
}

.custom-fields-errors {
  padding: 10px 20px;
  background-color: #ffebebeb;
  border: 1px solid #ff0000;
  margin: 10px;
  border-radius: 4px;
}

.custom-field-error {
  color: #333;
  margin-bottom: 5px;
}

.custom-field-error:last-child {
  margin-bottom: 0;
}

tambr-loading-spinner {
  text-align: center;
}